import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ShopPage from './pages/ShopPage';
import ProductPage from './pages/ProductPage';
import LeaderboardPage from './pages/LeaderboardPage';
import ComingSoonPage from './pages/ComingSoonPage';
import CartPage from './pages/CartPage';
import ProfilePage from './pages/ProfilePage';
import AddressesPage from './pages/AddressesPage';
import ReferralPage from './pages/ReferralPage';
import FAQPage from './pages/FAQPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsConditionsPage from './pages/TermsConditionsPage';
import ReturnPolicyPage from './pages/ReturnPolicyPage';
import ShippingPolicyPage from './pages/ShippingPolicyPage';
import SupportPage from './pages/SupportPage';
import GiftCardPurchasePage from './pages/GiftCardPurchasePage';
import GiftCardSuccessPage from './pages/GiftCardSuccessPage';
import AboutUsPage from './pages/AboutUsPage';
import WishlistPage from './pages/WishlistPage';
import CoinActivityPage from './pages/CoinActivityPage';
import OrdersPage from './pages/OrdersPage';
import CheckoutPage from './pages/CheckoutPage';
import OrderDetailsPage from './pages/OrderDetailsPage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import GoogleCallbackPage from './pages/GoogleCallbackPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import NotFoundPage from './pages/NotFoundPage';
import ProductListPage from './pages/admin/Products/ProductListPage';
import ProductFormPage from './pages/admin/Products/ProductFormPage';
import CategoriesPage from './pages/admin/Categories/CategoriesPage';
import TagsPage from './pages/admin/Tags/TagsPage';
import SizeChartsPage from './pages/admin/SizeCharts/SizeChartsPage';
import SizeChartForm from './pages/admin/SizeCharts/SizeChartForm';
import CustomerListPage from './pages/admin/Customers/CustomerListPage';
import CustomerFormPage from './pages/admin/Customers/CustomerFormPage';
import CustomerDetailsPage from './pages/admin/Customers/CustomerDetailsPage';
import OrdersListPage from './pages/admin/Orders/OrdersListPage';
import AdminOrderDetailsPage from './pages/admin/Orders/AdminOrderDetailsPage';
import AnalyticsPage from './pages/admin/AnalyticsPage';
import MadCoinsPage from './pages/admin/MadCoinsPage';
import ReferralsPage from './pages/admin/ReferralsPage';
import SettingsPage from './pages/admin/SettingsPage';
import BannerManagementPage from './pages/admin/BannerManagementPage';
import CouponsPage from './pages/admin/CouponsPage';
import GiftCardsPage from './pages/admin/GiftCardsPage';
import LogsPage from './pages/admin/LogsPage';
import DeletedLogsPage from './pages/admin/DeletedLogsPage';
import ProtectedRoute from './components/ProtectedRoute';
import AdminProtectedRoute from './components/AdminProtectedRoute';
import AdminLayout from './components/admin/AdminLayout';
import UserProtectedRoute from './components/UserProtectedRoute';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { WishlistProvider } from './context/WishlistContext';
import ScrollToTop from './components/ScrollToTop';
import './styles/App.css';
// import CloudflareImage from './components/ui/cloudflare-image';
// import { Badge } from './components/ui/badge';
// import { Button } from './components/ui/button';
// import { useNavigate, Link } from 'react-router-dom';
// import { useState, useEffect } from 'react';
// import { logoutAdmin } from './services/adminApi';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


// Wrapper component to render with Navbar and Footer
const MainLayout = ({ children }) => {
  return (
    <>
      <Navbar />
      <div className="content">{children}</div>
      <Footer />
    </>
  );
};

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <WishlistProvider>
          <Router>
            <ScrollToTop />
            <div className="App">
              <Routes>
            {/* Admin Routes - No Navbar/Footer */}
            <Route path="/admin-login" element={
              <div>
                <AdminLoginPage />
              </div>
            } />
            <Route path="/root-admin-dashboard/*" element={
              <AdminProtectedRoute>
                <AdminLayout>
                  {props => <AdminDashboardPage activeSection={props.activeSection} />}
                </AdminLayout>
              </AdminProtectedRoute>
            } />
            
            {/* Admin Product Management Routes */}
            <Route path="/admin/products" element={
              <ProtectedRoute>
                <AdminLayout>
                  <ProductListPage />
                </AdminLayout>
              </ProtectedRoute>
            } />
            <Route path="/admin/products/add" element={
              <ProtectedRoute>
                <AdminLayout>
                  <ProductFormPage />
                </AdminLayout>
              </ProtectedRoute>
            } />
            <Route path="/admin/products/edit/:id" element={
              <ProtectedRoute>
                <AdminLayout>
                  <ProductFormPage />
                </AdminLayout>
              </ProtectedRoute>
            } />
            <Route path="/admin/products/view/:id" element={
              <ProtectedRoute>
                <AdminLayout>
                  <ProductFormPage />
                </AdminLayout>
              </ProtectedRoute>
            } />
            <Route path="/admin/categories" element={
              <ProtectedRoute>
                <AdminLayout>
                  <CategoriesPage />
                </AdminLayout>
              </ProtectedRoute>
            } />
            <Route path="/admin/tags" element={
              <ProtectedRoute>
                <AdminLayout>
                  <TagsPage />
                </AdminLayout>
              </ProtectedRoute>
            } />

            {/* Admin User Management Routes */}
            <Route path="/admin/customers" element={
              <ProtectedRoute>
                <AdminLayout>
                  <CustomerListPage />
                </AdminLayout>
              </ProtectedRoute>
            } />
            <Route path="/admin/customers/new" element={
              <ProtectedRoute>
                <AdminLayout>
                  <CustomerFormPage />
                </AdminLayout>
              </ProtectedRoute>
            } />
            <Route path="/admin/customers/edit/:id" element={
              <ProtectedRoute>
                <AdminLayout>
                  <CustomerFormPage />
                </AdminLayout>
              </ProtectedRoute>
            } />
            <Route path="/admin/customers/view/:id" element={
              <ProtectedRoute>
                <AdminLayout>
                  <CustomerDetailsPage />
                </AdminLayout>
              </ProtectedRoute>
            } />
            
            <Route path="/admin/orders" element={
              <ProtectedRoute>
                <AdminLayout>
                  <OrdersListPage />
                </AdminLayout>
              </ProtectedRoute>
            } />

            <Route path="/admin/order/:orderNumber" element={
              <ProtectedRoute>
                <AdminLayout>
                  <AdminOrderDetailsPage />
                </AdminLayout>
              </ProtectedRoute>
            } />

            <Route path="/admin/analytics" element={
              <ProtectedRoute>
                <AdminLayout>
                  <AnalyticsPage />
                </AdminLayout>
              </ProtectedRoute>
            } />

            <Route path="/admin/mad-coins" element={
              <ProtectedRoute>
                <AdminLayout>
                  <MadCoinsPage />
                </AdminLayout>
              </ProtectedRoute>
            } />

            <Route path="/admin/referrals" element={
              <ProtectedRoute>
                <AdminLayout>
                  <ReferralsPage />
                </AdminLayout>
              </ProtectedRoute>
            } />

            <Route path="/admin/settings" element={
              <ProtectedRoute>
                <AdminLayout>
                  <SettingsPage />
                </AdminLayout>
              </ProtectedRoute>
            } />
            <Route path="/admin/banner" element={
              <ProtectedRoute>
                <AdminLayout>
                  <BannerManagementPage />
                </AdminLayout>
              </ProtectedRoute>
            } />
            <Route path="/admin/coupons" element={
              <ProtectedRoute>
                <AdminLayout>
                  <CouponsPage />
                </AdminLayout>
              </ProtectedRoute>
            } />
            <Route path="/admin/gift-cards" element={
              <ProtectedRoute>
                <AdminLayout>
                  <GiftCardsPage />
                </AdminLayout>
              </ProtectedRoute>
            } />
            <Route path="/admin/logs" element={
              <ProtectedRoute>
                <LogsPage />
              </ProtectedRoute>
            } />
            <Route path="/admin/deleted-logs" element={
              <ProtectedRoute>
                <DeletedLogsPage />
              </ProtectedRoute>
            } />

            {/* Auth Routes */}
            <Route path="/login" element={
              <MainLayout>
                <LoginPage />
              </MainLayout>
            } />
            <Route path="/register" element={
              <MainLayout>
                <RegisterPage />
              </MainLayout>
            } />
            <Route path="/auth/google/callback" element={<GoogleCallbackPage />} />
            <Route path="/verify-email" element={
              <MainLayout>
                <VerifyEmailPage />
              </MainLayout>
            } />
            <Route path="/forgot-password" element={
              <MainLayout>
                <ForgotPasswordPage />
              </MainLayout>
            } />
            <Route path="/reset-password/:token" element={
              <MainLayout>
                <ResetPasswordPage />
              </MainLayout>
            } />

            {/* Protected User Routes */}
            <Route path="/profile" element={
              <MainLayout>
                <UserProtectedRoute>
                  <ProfilePage />
                </UserProtectedRoute>
              </MainLayout>
            } />
            <Route path="/orders" element={
              <MainLayout>
                <UserProtectedRoute>
                  <OrdersPage />
                </UserProtectedRoute>
              </MainLayout>
            } />
            <Route path="/order/:orderNumber" element={
              <MainLayout>
                <UserProtectedRoute>
                  <OrderDetailsPage />
                </UserProtectedRoute>
              </MainLayout>
            } />
            <Route path="/addresses" element={
              <MainLayout>
                <UserProtectedRoute>
                  <AddressesPage />
                </UserProtectedRoute>
              </MainLayout>
            } />
            <Route path="/referral" element={
              <MainLayout>
                <UserProtectedRoute>
                  <ReferralPage />
                </UserProtectedRoute>
              </MainLayout>
            } />
            <Route path="/wishlist" element={
              <MainLayout>
                <UserProtectedRoute>
                  <WishlistPage />
                </UserProtectedRoute>
              </MainLayout>
            } />
            <Route path="/coin-activity" element={
              <MainLayout>
                <UserProtectedRoute>
                  <CoinActivityPage />
                </UserProtectedRoute>
              </MainLayout>
            } />

            {/* Public Routes */}
            <Route path="/" element={
              <MainLayout>
                <HomePage />
              </MainLayout>
            } />
            <Route path="/shop" element={
              <MainLayout>
                <ShopPage />
              </MainLayout>
            } />
            <Route path="/shop/:categorySlug" element={
              <MainLayout>
                <ShopPage />
              </MainLayout>
            } />
            <Route path="/product/:id" element={
              <MainLayout>
                <ProductPage />
              </MainLayout>
            } />
            <Route path="/leaderboard" element={
              <MainLayout>
                <LeaderboardPage />
              </MainLayout>
            } />
            <Route path="/cart" element={
              <MainLayout>
                <CartPage />
              </MainLayout>
            } />
            <Route path="/checkout" element={
              <MainLayout>
                <UserProtectedRoute>
                  <CheckoutPage />
                </UserProtectedRoute>
              </MainLayout>
            } />
            <Route path="/faq" element={
              <MainLayout>
                <FAQPage />
              </MainLayout>
            } />
            <Route path="/privacy-policy" element={
              <MainLayout>
                <PrivacyPolicyPage />
              </MainLayout>
            } />
            <Route path="/terms-conditions" element={
              <MainLayout>
                <TermsConditionsPage />
              </MainLayout>
            } />
            <Route path="/return-policy" element={
              <MainLayout>
                <ReturnPolicyPage />
              </MainLayout>
            } />
            <Route path="/shipping-policy" element={
              <MainLayout>
                <ShippingPolicyPage />
              </MainLayout>
            } />
            <Route path="/support" element={
              <MainLayout>
                <SupportPage />
              </MainLayout>
            } />
            <Route path="/gift-cards" element={
              <MainLayout>
                <UserProtectedRoute>
                  <GiftCardPurchasePage />
                </UserProtectedRoute>
              </MainLayout>
            } />
            <Route path="/gift-cards/success" element={
              <MainLayout>
                <UserProtectedRoute>
                  <GiftCardSuccessPage />
                </UserProtectedRoute>
              </MainLayout>
            } />
            <Route path="/about-us" element={
              <MainLayout>
                <AboutUsPage />
              </MainLayout>
            } />
            <Route path="/market" element={
              <MainLayout>
                <ComingSoonPage />
              </MainLayout>
            } />
            <Route path="/auctions" element={
              <MainLayout>
                <ComingSoonPage />
              </MainLayout>
            } />
            <Route path="/spotted" element={
              <MainLayout>
                <ComingSoonPage />
              </MainLayout>
            } />
            <Route path="/irl" element={
              <MainLayout>
                <ComingSoonPage />
              </MainLayout>
            } />
            <Route path="/recruit" element={
              <MainLayout>
                <ComingSoonPage />
              </MainLayout>
            } />

            {/* Admin Routes */}
            <Route path="/admin/size-charts" element={
              <ProtectedRoute>
                <AdminLayout>
                  <SizeChartsPage />
                </AdminLayout>
              </ProtectedRoute>
            } />
            <Route path="/admin/size-charts/add" element={
              <ProtectedRoute>
                <AdminLayout>
                  <SizeChartForm />
                </AdminLayout>
              </ProtectedRoute>
            } />
            <Route path="/admin/size-charts/edit/:id" element={
              <ProtectedRoute>
                <AdminLayout>
                  <SizeChartForm />
                </AdminLayout>
              </ProtectedRoute>
            } />
            <Route path="/admin/size-charts/view/:id" element={
              <ProtectedRoute>
                <AdminLayout>
                  <SizeChartForm />
                </AdminLayout>
              </ProtectedRoute>
            } />
            
            {/* Catch-all 404 route */}
            <Route path="*" element={
              <MainLayout>
                <NotFoundPage />
              </MainLayout>
            } />
          </Routes>
          <ToastContainer
            position="bottom-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </div>
      </Router>
        </WishlistProvider>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
